import type { FaireProductEntity } from "../../entity_types/product";

export const p_6te9b6dadp: FaireProductEntity = {
  token: "p_6te9b6dadp",
  type: "product",
  name: "Women's Slim Notch Collar Long Sleeve Short PJ Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/4bc4b51e4eb6ce60864f641fe4f3669a76aaf32bbeb685b23adebbc10257c9bc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/26f42c9c707596576728f311d89b4227f8f8e83f7ec9c66f38a842ec6fe45d2d.jpeg",
    "https://cdn.faire.com/fastly/59d3d5b4690795a55dfa72d3ed226dc6552711a1d301f592e86dc5a5d0d028be.jpeg",
    "https://cdn.faire.com/fastly/07a27f89079e6fc0d26d07252494d3ae115c00eaaff525985751311e71a8156e.png",
    "https://cdn.faire.com/fastly/f2198dda97a1a84d4790bd79dd94ca8a58ef43dfa5f22cd1d3d19df3588a412c.jpeg",
    "https://cdn.faire.com/fastly/8372cb2348aec394a30e467f66d54e9059d0e28ef7fe4c4b0918b63a9bfeba5a.jpeg",
    "https://cdn.faire.com/fastly/9dc64b4dc9c4e7e31ea80e7a33c52c198e4744f57fcee6354c29272f35179b32.jpeg",
    "https://cdn.faire.com/fastly/cd01c7e10aca93da4ff99755c58760b9eb7c6d720305ed0b50f5185515dff10d.png",
    "https://cdn.faire.com/fastly/554e9ae289a50c369fa747fc3ea868eca95982c0a959015054e7fa00979b1cac.jpeg",
    "https://cdn.faire.com/fastly/70e7188f91ad3e00896ebf46c6be60150d20c82d3162078d0756831648966c85.jpeg",
    "https://cdn.faire.com/fastly/376c3fdfb6cd38d20583246d0f2f6613d8ea1772c910b94b087b750a8d5381d6.jpeg",
    "https://cdn.faire.com/fastly/514dfd2e8d22fc6bf7eb49424f1a52e9ba1fb2a8391d37a1c62101fd0c1be823.png",
    "https://cdn.faire.com/fastly/2ef006042096ca573824456956eb142f479bc0c139aaf577a579ccc7a903a4a2.jpeg",
    "https://cdn.faire.com/fastly/825299de6457f7332cc7c1ce5564cbb6bb188c133df3f266cae6fa77569faf12.png",
    "https://cdn.faire.com/fastly/a29b1fd4924b63e2ee733f718158bb82a5a6709385eb1e1afdc039850d124374.png",
    "https://cdn.faire.com/fastly/b8b83188550d40f8d41f367201cf3412ca7d4a76b887d94b9d747f4f08439453.png",
    "https://cdn.faire.com/fastly/e963c6acd9042fa77060ac086cacfc0d4529a69d528562dd9cfb8fad0e3d427e.png",
    "https://cdn.faire.com/fastly/c12491cd71ab2d985470b7853e1562952443529a26b05ed8088b59e907bdf74b.png",
    "https://cdn.faire.com/fastly/636eaf7942cea7dee0201be989be3656d6a16884f4f47fab243b0a7b05b5b13d.png"
  ],
  priceDollars: 60,
  description: "Introducing the Aria - Slim Notch Collar PJ Set in Wild Animal Print and Cherry Cola, a testament to lavish comfort. The fine ribbing of the fabric sets this PJ set apart for a buttery soft touch you have to feel to believe. Designed with just the right amount of stretch, it ensures a flattering fit, hugging the body in all the right places while allowing for ease of movement.\n\nThe set features a classic notch collar, drawstring waist and pockets – blending traditional design with modern comfort. The material drapes like a dream and has a cooling quality that makes it perfect for a restful night’s sleep.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n• Slim notch collar top\n• Long sleeve full button front\n• Wrapped in a Softies’ branded belly band\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞\n• Easy care, colorfast and machine washable\n• Softies breathable Wellness Fabric is 96% modal, 4% spandex blend",
  tags: [],
  msrpDollars: 129,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:16.062Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
